import type { Destination, Resort } from '@/shared/model';
import { matchesDestinationName } from './matchDestinationName';
import { sortOptions } from './sortOptions';
import { DESTINATION_MOBILE_TEXTS } from '../config/texts';
import type { OptionGroup, ResortGroupTitles } from '../model/types';

function toResortDestination(resort: Resort): Destination {
  return { type: 'resort', country: null, resort, hotel: null };
}

function isPopularResortGroup(group: OptionGroup): boolean {
  return group.items.some((item) => item.type === 'resort' && item.resort.isPopular);
}

export function getResortGroups(resorts: readonly Resort[], query: string, titles?: ResortGroupTitles): OptionGroup[] {
  const normalizedQuery = query.trim().toLowerCase();
  if (normalizedQuery === '') {
    const groups = sortOptions(resorts.map((resort) => toResortDestination(resort)));

    if (!titles) return groups;

    return groups.map((group) => ({
      ...group,
      title: isPopularResortGroup(group) ? titles.popular : titles.other,
    }));
  }
  const filtered = resorts.filter((resort) => matchesDestinationName(resort.name, normalizedQuery));
  if (filtered.length === 0) {
    return [];
  }
  return [
    {
      title: DESTINATION_MOBILE_TEXTS.groupResorts,
      kind: 'resort',
      items: filtered.map((resort) => toResortDestination(resort)),
    },
  ];
}
